import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import hasAccess from "./hasAccess";

const ProtectedModuleRoute = ({ module, children }) => {
  const loggedUser = useSelector((state) => state.users.loggedUser);

  const isLoggedIn = loggedUser && Object.keys(loggedUser).length > 0;

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAccess(loggedUser, module)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedModuleRoute;
